module.exports = new function generalSlider()
{

    const Flickity = require('flickity');
    const sliders = document.querySelectorAll('[data-js="general-slider"]');

    if (sliders.length > 0) {
        console.log(sliders.length > 0);
        for (let i = 0; i < sliders.length; i++ ) {

            let flkty = new Flickity(sliders[i], {
                cellSelector: '.general-slider-cell',
                cellAlign: 'center',
                autoPlay: 5000,
                initialIndex: 1,
                wrapAround: true,
                lazyLoad: 3
            });

            window.addEventListener( 'load', function() { flkty.resize() });
        }
    }

}
